(() => {
  'use strict';
  const selector = '.wh-native-product-form, .wh-embedded-reference-form';
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches(selector) || event.defaultPrevented) return;
    if (!form.reportValidity()) return;
    event.preventDefault();
    if (form.dataset.cfusPending === 'true') return;
    form.dataset.cfusPending = 'true';
    const buttons = [...form.querySelectorAll('[type="submit"]')];
    if (event.submitter && !buttons.includes(event.submitter)) buttons.push(event.submitter);
    const states = buttons.map(button => [button, button.disabled]);
    states.forEach(([button]) => { button.disabled = true; });
    let message = form.querySelector('[data-cfus-error]');
    if (!message) {
      message = document.createElement('p');
      message.dataset.cfusError = 'true';
      message.setAttribute('role', 'alert');
      form.append(message);
    }
    message.textContent = '';
    const root = window.Shopify?.routes?.root || '/en-us/';
    try {
      // Use the existing Comfi fetch hook; it sends and deduplicates AddToCart.
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      });
      const body = await response.json();
      if (!response.ok || body.status) throw new Error(body.description || body.message || 'Unable to add this item. Please try again.');
      // Allow the existing event/attribute queue to settle before leaving the page.
      let timer;
      await Promise.race([
        Promise.all((window.comfiPendingCartAdds || []).slice()),
        new Promise(resolve => { timer = setTimeout(resolve, 1500); })
      ]).finally(() => clearTimeout(timer));
      window.location.assign(root + 'cart');
    } catch (error) {
      message.textContent = error.message || 'Unable to add this item. Please try again.';
    } finally {
      delete form.dataset.cfusPending;
      states.forEach(([button, disabled]) => { button.disabled = disabled; });
    }
  });
})();
